import storage from "redux-persist/lib/storage";
import { buildStore, store } from "Data/Redux/Store";
import {
	type PersistConfig, persistStore, persistReducer, createTransform
} from "redux-persist";
import { type AppState, rootReducer } from "Data/Redux/Reducers";
import { produce } from "immer";
import type { PlaybackState } from "Interfaces";

const persistTransform = createTransform(
	(inboundState, key) => {
		switch (key) {
			case "playback":
				return produce(inboundState as PlaybackState, (draft) => {
					draft.date = null;
					draft.videoPlayerTime = null;
					draft.clipModeActive = false;
				});

			default:
				return inboundState;
		}
	}
);

const persistConfig: PersistConfig<AppState> = {
	key: "ip-camera-web",
	storage,
	transforms: [ persistTransform ]
};

buildStore(
	persistReducer(persistConfig, rootReducer),
	{}
);

export const persistor = persistStore(store);
